import type {
  BoardViewResponse,
  ProjectDetail,
  Ticket,
  TicketPriority,
  TicketState,
} from '@localagent/sdk';

export const BOARD_COLUMNS: TicketState[] = [
  'backlog',
  'todo',
  'in_progress',
  'in_review',
  'done',
  'cancelled',
];

export const TICKET_STATE_LABELS: Record<TicketState, string> = {
  backlog: 'Backlog',
  todo: 'Todo',
  in_progress: 'In Progress',
  in_review: 'In Review',
  done: 'Done',
  cancelled: 'Cancelled',
};

export const PRIORITY_LABELS: Record<TicketPriority, string> = {
  urgent: 'Urgent',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  none: 'None',
};

export const PRIORITY_COLORS: Record<TicketPriority, string> = {
  urgent: 'bg-error-solid text-error-solid-foreground',
  high: 'bg-warning-solid text-warning-solid-foreground',
  medium: 'bg-warning-subtle text-warning-text',
  low: 'bg-info-subtle text-info-text',
  none: 'bg-muted text-foreground-secondary',
};

export const TICKET_STATUS_LABELS: Record<string, string> = {
  specifying: 'Specifying',
  ready: 'Ready',
  needs_input: 'Needs Input',
  planning: 'Planning',
  executing: 'Executing',
  validating: 'Validating',
  changes_requested: 'Changes Requested',
  wont_fix: "Won't Fix",
  duplicate: 'Duplicate',
};

export const STATE_COLORS: Record<TicketState, string> = {
  backlog: 'bg-muted text-foreground-secondary',
  todo: 'bg-chart-1/15 text-chart-1',
  in_progress: 'bg-info-subtle text-info-text',
  in_review: 'bg-chart-6/15 text-chart-6',
  done: 'bg-success-subtle text-success-text',
  cancelled: 'bg-error-subtle text-error-text',
};

export function projectDetailToBoard(detail: ProjectDetail): BoardViewResponse {
  const columns = BOARD_COLUMNS.map((state) => ({ state, tickets: [] as Ticket[] }));
  const byState = new Map(columns.map((column) => [column.state, column.tickets]));
  for (const ticket of detail.tickets) {
    const tickets = byState.get(ticket.state);
    if (!tickets) {
      throw new Error(`ticket ${ticket.identifier} has unknown state ${ticket.state}`);
    }
    tickets.push(ticket);
  }
  // Zero by construction: a project board holds only that project's tickets
  // (work_management ADR-024).
  return { team_id: detail.project.team_id, columns, orphan_ticket_count: 0 };
}
